/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensalidadeNotaFiscalAliases {
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FORM_NF = 'form-nf',
  LINK_0 = 'link-0',
  MAPPER_0 = 'mapper-0',
  PANEL_NFE = 'panel-nfe',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { MensalidadeNotaFiscalAliases };
